<template>
<w-flex justify-center>
  <w-spinner fade color="green" />
  <w-spinner fade color="amber" />
  <w-spinner fade color="orange" />
  <w-spinner fade color="error" />
  <w-spinner fade color="pink" />
</w-flex>
</template>


<script>
export default {
  name: 'LoadingSpinner',
}
</script>
